import { Injectable, inject } from '@angular/core';
import { OrganizationHierarchyFlowType } from 'src/app/dashboards/models/spatial.models';
import { LocalSettingsService } from '../../local-settings/local-settings.service';

@Injectable({
  providedIn: 'root',
})
export class HierarchyFlowPreferenceService {
  private readonly localSettingsService = inject(LocalSettingsService);
  private readonly preferenceKey = 'hierarchyFlowPreference';

  public getPreferredFlow(userId?: string): OrganizationHierarchyFlowType | undefined {
    const value = this.localSettingsService.getUserPreferences(userId)[this.preferenceKey];
    return this.parseFlowType(value);
  }

  public setPreferredFlow(flow: OrganizationHierarchyFlowType, userId?: string): void {
    this.localSettingsService.setUserPreferences({ [this.preferenceKey]: flow }, userId);
  }

  private parseFlowType(value: unknown): OrganizationHierarchyFlowType | undefined {
    switch (value) {
      case OrganizationHierarchyFlowType.Meter:
        return OrganizationHierarchyFlowType.Meter;
      case OrganizationHierarchyFlowType.Space:
        return OrganizationHierarchyFlowType.Space;
      default:
        return undefined;
    }
  }
}
